import React, { useEffect, useState } from 'react';
import Layout from './layout';
import {
  getTemplates,
  createTemplate,
  updateTemplate,
  deleteTemplate,
} from './api/templateApi';

function TemplateCRUDPage() {
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ title: '', message: '' });
  const [editId, setEditId] = useState(null);

  const fetchTemplates = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await getTemplates();
      setTemplates(data.templates || data); // support both array and {templates: []}
    } catch (err) {
      setError('Failed to fetch templates');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleAdd = () => {
    setFormData({ title: '', message: '' });
    setEditId(null);
    setShowForm(true);
  };

  const handleEdit = (template) => {
    setFormData({
      title: template.title || '',
      message: template.message || '',
    });
    setEditId(template.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this template?')) return;
    try {
      await deleteTemplate(id);
      fetchTemplates();
    } catch {
      setError('Failed to delete template');
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editId) {
        await updateTemplate(editId, formData);
      } else {
        await createTemplate(formData);
      }
      setShowForm(false);
      fetchTemplates();
    } catch {
      setError('Failed to save template');
    }
  };

  return (
    <Layout>
      <div className="container p-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2>Templates</h2>
          <button className="btn btn-primary" onClick={handleAdd}>Add Template</button>
        </div>
        {error && <div className="alert alert-danger">{error}</div>}
        {loading ? (
          <div>Loading...</div>
        ) : (
          <table className="table table-bordered table-striped">
            <thead>
              <tr className='row'>
                <th className='col-md-4'>Title</th>
                <th className='col-md-5'>Message</th>
                <th className='col-md-3'>Actions</th>
              </tr>
            </thead>
            <tbody>
              {templates.length === 0 && (
                <tr><td colSpan={3} className="text-center">No templates found.</td></tr>
              )}
              {templates.map((template) => (
                <tr key={template.id} className='row'>
                  <td className='fw-bold col-md-4'>{template.title}</td>
                  <td className='col-md-5'>{template.message}</td>
                  <td className='col-md-3'>
                    <button className="btn btn-sm btn-secondary me-2" onClick={() => handleEdit(template)}>Edit</button>
                    <button className="btn btn-sm btn-danger" onClick={() => handleDelete(template.id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {/* Modal/Form for Add/Edit */}
        {showForm && (
          <div className="modal show d-block" tabIndex="-1" role="dialog" style={{background: 'rgba(0,0,0,0.3)'}}>
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <form onSubmit={handleFormSubmit}>
                  <div className="modal-header">
                    <h5 className="modal-title">{editId ? 'Edit Template' : 'Add Template'}</h5>
                    <button type="button" className="btn-close" onClick={() => setShowForm(false)} aria-label="Close"></button>
                  </div>
                  <div className="modal-body">
                    <div className="mb-3">
                      <label className="form-label">Title</label>
                      <input type="text" className="form-control" name="title" value={formData.title} onChange={handleInputChange} required />
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Message</label>
                      <textarea className="form-control" name="message" value={formData.message} onChange={handleInputChange} required />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={() => setShowForm(false)}>Cancel</button>
                    <button type="submit" className="btn btn-primary">Save</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}

export default TemplateCRUDPage; 